import { ColorsIds } from '../../const/utils-android-shared.const';

export type NavBarColor<R> = { [key in keyof typeof ColorsIds]: R };

export interface INavColor {
  dark: INavStyle,
  light: INavStyle
}

export interface INavStyle {
  color: string;
  darkButtons: boolean;
}
